'use client';

import { toastError, toastInfo, toastSuccess, toastWarning } from '@/lib/toast';
import { useCallback } from 'react';

export function useToast() {
  const success = useCallback((message, description, duration) => {
    toastSuccess(message, duration, undefined, description);
  }, []);

  const info = useCallback((message, description, duration) => {
    toastInfo(message, duration, undefined, description);
  }, []);

  const warning = useCallback((message, description, duration) => {
    toastWarning(message, duration, undefined, description);
  }, []);

  const error = useCallback((message, description, duration) => {
    toastError(message, duration, undefined, description);
  }, []);

  return { success, info, warning, error };
}